import type { ReactNode } from "react";
import { cn } from "@/lib/utils.ts";

interface TrainingCompletionShellProps {
  bgClassName: string;
  numberLabel?: string;
  title: string;
  subtitle?: string | null;
  body?: ReactNode;
  decorations?: ReactNode;
  children?: ReactNode;
}

export function TrainingCompletionShell({
  bgClassName,
  numberLabel,
  title,
  subtitle,
  body,
  decorations,
  children,
}: TrainingCompletionShellProps) {
  return (
    <div
      className={cn(
        "relative flex min-h-screen w-full items-center justify-center overflow-hidden p-6",
        bgClassName,
      )}
    >
      {decorations}

      <div className="relative z-10 flex flex-col items-center gap-12 text-text-primary">
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-4">
            <div className="flex items-start gap-3">
              {numberLabel && (
                <span className="font-mono text-header-6 opacity-75">
                  {numberLabel}
                </span>
              )}
              <h1 className="font-heading font-bold text-[84px] leading-[0.9] tracking-[-0.03em]">
                {title}
              </h1>
            </div>
            {subtitle && (
              <p className="text-body-1 opacity-50">{subtitle}</p>
            )}
          </div>
          {body && (
            <div className="max-w-[620px] text-center text-body-1 opacity-75">
              {body}
            </div>
          )}
        </div>

        {children}
      </div>
    </div>
  );
}
